import React from 'react'
import spendingAlertSuccess from "../../../../../assets/images/spending-alert-success.png"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useDispatch, useSelector } from 'react-redux'
import logFirebaseEvents from '../../../../LogFirebaseEvents';
import { appTheme } from '../../../../../helpers/utils/Utils';
import SavingGoalIcon from '../../../../../assets/kudzu-plus-images/savingGoalIcon.png'



const SavingGoalsAleart = ({ onCanelTranfer, isCancelButton ,onBack}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);

    const handleAllocateFund = () => {
        logFirebaseEvents("Saving_Goal", "Allocate_Fund_Clicked", "Allocate_Fund_Clicked","", "")
        dispatch({ type: 'MODAL_SAVING_GOAL', payload: { modalvalueSavingGoal: false } });
        navigate('/Climb/AllocateFund');
        dispatch({ type: "RESET_ALLOCATE_FUND" })
        dispatch({
            type: "SELECTED_FREQUENCY_VALUE",
            payload: { selectedFrequencyValue : {}  },
            }); 
    }

    const handleCreateGoal = () => {
        logFirebaseEvents("Saving_Goal", "Create_Saving_Goal_Clicked", "Create_Saving_Goal_Clicked","", "")
        // dispatch({ type: "RESET_ADD_SPEND_ALERTS" })
        dispatch({ type: 'MODAL_SAVING_GOAL', payload: { modalvalueSavingGoal: false } });
        dispatch({ type: "RESET_SAVING_GOALS" })
        navigate('/Toolkit/SavingGoals/ManageSavingGoal');
        onBack("SavingGoalFields")
    }

    return (
        <div className='flex flex-col justify-center items-center w-full'>
            <p className='font-hanken-grotesk lg:text-[19px] md:text-[17px] sm:text-[14px] text-[16px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] 
             md:leading-[28px] text-[var(--heading-in-modal-is-clr)] '>{t("add_Some_Funds_Text")}</p>

            <img src={SavingGoalIcon} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />
            <div className='flex flex-col justify-center items-center w-full'>

                <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                    <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
 sm:text-[15px] text-[16px] font-[400] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={ handleAllocateFund} onKeyDown={(e) => { if (e.key === "Enter") handleAllocateFund() }}>{t("Allocate_Funds")}</button>
                
                        <button class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
 sm:text-[15px] text-[16px] font-[400] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px]  text-white cursor-pointer border-2 px-2 py-4 border-[#4B70B9] w-full    " onClick={ handleCreateGoal} onKeyDown={(e) => { if (e.key === "Enter") handleCreateGoal() }}>{t("Create_Another_Goal")}</button>
                    
                </div>
            </div>

        </div>
    )
}

export default withOidcSecure(SavingGoalsAleart)